import React, { useEffect, useState } from "react";
import Header from "../Home/Header/Header";
import { CircularProgress } from "@mui/material";
import { QrReader } from "react-qr-reader";
import "./TvConnect.scss";
import { scannerActive } from "../../Recoil/atom";
import { useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";

const TvConnect = () => {
  const [isLoading, setIsLoading] = useState(false);
  const activeTab = useRecoilValue(scannerActive);
  const [manualInput, setManualInput] = useState("");
  const [permissionGranted, setPermissionGranted] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    navigator?.mediaDevices
      ?.getUserMedia({ video: true })
      .then((stream) => {
        stream.getTracks().forEach((t) => t.stop());
        setPermissionGranted(true);
      })
      .catch(() => setPermissionGranted(false));
  }, []);

  const handleManualSave = () => {
    if (manualInput.trim()) {
      addScan(manualInput.trim());
      setManualInput("");
    }
  };

  const addScan = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      navigate("/DevicesSet");
      setIsLoading(false);
    }, 3000);
  };

  return (
    <div>
      {isLoading && (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      )}
      <Header otherPage={true} title="Tv Connect" />
      <div style={{ padding: "70px 10px" }}>
        <div>
          {activeTab == "scanner" ? (
            <div className="qr-scanner-box">
              <QrReader
                constraints={{ facingMode: "environment" }}
                scanDelay={100}
                onResult={(result, error) => {
                  if (result) {
                    const jobNumber = result?.text || "";
                    if (jobNumber.length > 3) {
                      addScan(jobNumber);
                    }
                  }
                  if (error) {
                    console.error("QR Scan Error:", error);
                  }
                }}
                videoStyle={{ width: "100%", borderRadius: 8 }}
                style={{ width: "100%" }}
              />
            </div>
          ) : (
            <div className="manual-input">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: 600,
                    margin: "5px",
                  }}
                >
                  Manual Scanne
                </p>
                <p
                  style={{
                    width: "80%",
                    textAlign: "center",
                    margin: "2px",
                    fontSize: "12px",
                    color: "#867d7d",
                  }}
                >
                  Enter the random number this number can show your Tv screen,
                  Endter the number clikc the save Button{" "}
                </p>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  gap: "5px",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "7px",
                }}
              >
                <input
                  type="text"
                  value={manualInput}
                  onChange={(e) => setManualInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleManualSave();
                    }
                  }}
                  placeholder="Enter job number"
                />
                <button onClick={handleManualSave}>Save</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TvConnect;
